export default __webpack_public_path__ + "static/media/facebook.f35e88be.svg";